<template>
  <div
    class="min-h-screen flex-1 mt-1 bg-gray-100 px-4 pt-12 shadow-lg items-center"
  >
    <div class="bg-white w-fullrounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-5">
        <div class="flex">
          <button
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()"
          >
            <i class="material-icons">chevron_left</i>
          </button>
          <div v-if="!formData._id" class="text-2xl font-bold text-blue-500">
            New Avoir
          </div>
          <div v-else class="text-2xl font-bold text-blue-500">Edit Avoir</div>
          <img v-if="formData.warehouse" :src="formData.warehouse.flag" alt="" class="h-4 w-5 blob green ml-4" />
        </div>
      </div>

      <div class="">
        <div class="bg-white rounded-lg p-6">
          <div class="bg-white rounded-lg p-6">
                  <div class="grid lg:grid-cols-2 gap-6">
                      <div  class="border seller-select h-10 hover:border-blue-400 focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                        <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                          <p>
                            <label for="seller" class="bg-white text-gray-700 px-1"> Seller
                            <span :class="$colors.required">*</span></label>
                          </p>
                        </div>    
                        <p>
                            <v-select label="fullName" @search="getUsersDebance($event,'shipsen')" v-model="formData.seller" :options="sellers"></v-select>
                        </p>
                        
                      </div>  
                     
                      <div class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                              <p>
                                  <label for="customerPhone" class="bg-white text-gray-700 px-1">Avoir amount
                                      <span :class="$colors.required">*</span></label>
                              </p>
                          </div>
                          <p>
                              <input id="fees" autocomplete="false" tabindex="0" type="number" min="0" v-model="formData.amount" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                          </p>
                      </div>
                     
                  </div>  
                  <div class="grid lg:grid-cols-2 gap-6 pt-4">
                      <div
                          class="border hover:border-blue-400 w-full focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
                          <div class="-mt-4 absolute tracking-wider px-1 capitalize text-xs">
                              <p>
                                  <label for="customerPhone" class="bg-white text-gray-700 px-1">Comment</label>
                              </p>
                          </div>
                          <p>
                              <textarea  autocomplete="false" tabindex="0" type="text" v-model="formData.comment" class="py-2 text-xs px-2 outline-none block h-full w-full" />
                          </p>
                      </div>
                  </div>
          </div>     

          <div class="mt-6 pt-3 flex justify-center">
            <button
              class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-blue-500 hover:shadow-inner hover:bg-blue-700 transition-all duration-300"
              @click="save"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- ******************* Partie Script *********************** -->
<script>
export default {
  props: {
        currentUser: { type: Object},
        idWharhouse: { type: Object}
  },
  data() {
    return {
      formData: {warehouse:{}},
      sellers:[],
    };
  },
   watch: {
      //  "$store.state.wharhouse": {
      //       handler(newValue, oldValue) {
      //            this.formData.warehouse = newValue.warehousesUser.find(x=>x.country==newValue.warhouseSelected);
      //            console.log('this.warehouse----------',this.formData.warehouse)
      //       },
      //       deep: true
      //   },
        'idWharhouse': async function(oldVal, newVal) {
           this.idWharhouse=oldVal;  
           this.formData.warehouse = this.idWharhouse;
           await this.getSellers();
        }
  },
  async mounted() {
    await this.dataToEdit();
    await this.getSellers();
  },
  methods: {
     RouterBack: function() {
       this.$router.back();
    },
    getUsersDebance: _.debounce(async function(name) {
     if(this.formData.warehouse){
            await this.$store.dispatch('wharhouse/searchUser',{type: "Seller",warhouse:this.idWharhouse._id,search:name}).then((res) => {
              this.sellers = res
            })
      }     
     }, 500), 
     async getSellers() {
      if(this.formData.warehouse){
             const filter = {
              type: "Seller",
              warehouses:this.idWharhouse._id,
              limit:10
            };
            const res = await this.$server.search("users", filter);
            if (res && res.content.results) this.sellers = res.content.results;
            else this.sellers = [];
            }
    },
    async save() {
      if (this.formData._id) {

        const data = await this.$server.update("avoirs", this.formData);
        if(data && data._id) alert("Avoir updated", "success");
        else alert(data, "warning");

        }else {
          if(this.checkData()) {
            const data = await this.$server.create("avoirs", this.formData);
            if (data && data._id) {
              this.formData.seller=null; this.formData.amount=null; this.formData.comment=null;
              alert("Avoir created !", "success");
            } else alert(data, "warning");
          } else alert(`you must fill all the fields !! `, "warning");
      }
    },
    checkData() {
      if (this.formData.seller && this.formData.amount && this.formData.warehouse) return true;
      else return false;
    },
    async dataToEdit() {
      if (this.$route.params.id) {
        const editData = await this.$server.get("avoirs", {id: this.$route.params.id,});
        this.formData = editData.content;
      }
       this.formData.warehouse = this.idWharhouse;
    },
  },
};
</script>

<!-- ******************* Partie style *********************** -->
<style >
[type="color"] {
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  padding: 0;
  width: 15px;
  height: 15px;
  border: none;
}

[type="color"]::-webkit-color-swatch-wrapper {
  padding: 0;
}

[type="color"]::-webkit-color-swatch {
  border: none;
}

.color-picker {
  padding: 10px 15px;
  border-radius: 10px;
  border: 1px solid #ccc;
  background-color: #f8f9f9;
}
</style>